import React from 'react'
import { Card } from './Card'

interface StatCardProps {
  icon: string
  label: string
  value: string | number
  sub?: string
  color?: string
  onClick?: () => void
  style?: React.CSSProperties
  padding?: string
}

export const StatCard: React.FC<StatCardProps> = ({
  icon, label, value, sub, color, onClick, style, padding = '1.25rem',
}) => (
  <Card
    padding={padding}
    style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
    onClick={onClick}
  >
    <div style={{ fontSize: '1.5rem', marginBottom: '0.35rem' }}>{icon}</div>
    <div style={{ fontSize: '0.75rem', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.25rem' }}>{label}</div>
    <div style={{ fontSize: '1.4rem', fontWeight: 700, color: color ?? 'var(--text-primary)', lineHeight: 1.2 }}>{value}</div>
    {sub && <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: '0.25rem' }}>{sub}</div>}
  </Card>
)
